module.exports = __webpack_public_path__ + "img/12a)Campeon.jpg";